import { CardContents, Shop } from "@/types/v2";
import { ManualCardOptions } from "@/components/Settings/Cards/ManualCardOptions";
import { updateCardContents } from "@/lib/shop";

type ManualCardSettingsProps = {
  shopData: Shop;
};

export const ManualCardSettings = ({ shopData }: ManualCardSettingsProps) => {
  const handleCardContentsChange = (values: Partial<CardContents>) => {
    if (!shopData) return;
    return updateCardContents(shopData, values);
  };

  return (
    <ManualCardOptions shop={shopData} onSubmit={handleCardContentsChange} />
  );
};
